import {
  EBUY_TYPE,
  FIND_A_TENDER_TYPE,
  MANUAL_TYPE,
  SAM_GOV_TYPE,
} from "constants/opportunities";
import { OPPORTUNITY_REQUIRED_FIELDS } from "pages/capture/TrackedOpportunities/constants";
import { oppToFormData } from "pages/capture/TrackedOpportunities/helpers";
import {
  editEBuyOpportunityFromTracked,
  editFindATenderOpportunityFields,
  editOpportunity,
  editSamGovOpportunityFields,
} from "slices/opportunity/summary/actions";

import buildEBuyGroups from "./builders/EBuy/EBuyGroupBuilder";
import buildFindATenderGroups from "./builders/FindATender/FindATenderGroupBuilder";
import buildManualGroupsWithTypeSelector from "./builders/Manual/ManualGroupBuilderWithTypeSelector";
import buildSamGovGroups from "./builders/SamGov/SamGovGroupBuilder";

const EBUY_ENRICHMENT_FIELDS = [
  "upiid",
  "naicsCode",
  "followOnRequirement",
  "previousRfiInformation",
  "contractType",
  "delivery",
  "awardMethod",
  "category",
  "contactName",
  "contactEmail",
  "contactPhone",
  "contractVehicle",
  "competitionType",
  "qaDeadline",
];

const EDIT_OPPORTUNITY_TITLE = "Edit Opportunity";

const toBuilderProps = (ctx) => ({
  opportunity: ctx.opportunity,
  formData: ctx.formData,
  onChangeValue: ctx.setFieldValue,
  focusField: ctx.focusField,
  defaultCurrencyCode: ctx.defaultCurrencyCode,
});

const OPP_EDIT_PANEL_CONFIG = {
  [MANUAL_TYPE]: {
    getInitialFormData: (opportunity) => oppToFormData(opportunity),
    getRequiredFields: () => OPPORTUNITY_REQUIRED_FIELDS,
    getTitle: (opportunity) =>
      `${opportunity ? "Edit" : "Add New"} Opportunity`,
    buildGroups: (ctx) => buildManualGroupsWithTypeSelector(ctx),
    validate: (_, ctx) => ({ isInvalid: !ctx.oppType, fieldErrors: {} }),
    submit: (dispatch, opportunity, formData, ctx) =>
      dispatch(
        editOpportunity({ ...formData, id: opportunity.id }, ctx.oppType)
      ),
  },
  [SAM_GOV_TYPE]: {
    getInitialFormData: (opportunity) => ({
      estimatedValue: opportunity?.estimatedValue ?? "",
      externalLink: opportunity?.externalLink ?? "",
    }),
    getRequiredFields: () => [],
    getTitle: () => EDIT_OPPORTUNITY_TITLE,
    buildGroups: (ctx) => buildSamGovGroups(toBuilderProps(ctx)),
    submit: (dispatch, opportunity, formData) =>
      dispatch(
        editSamGovOpportunityFields({
          id: opportunity.id,
          title: opportunity.title,
          externalLink: formData.externalLink,
          ...(opportunity.estimatedValueIsFromSource
            ? {}
            : { estimatedValue: formData.estimatedValue }),
        })
      ),
  },
  [FIND_A_TENDER_TYPE]: {
    getInitialFormData: (opportunity) => ({
      estimatedValue: opportunity?.estimatedValue ?? "",
      externalLink: opportunity?.externalLink ?? "",
    }),
    getRequiredFields: () => [],
    getTitle: () => EDIT_OPPORTUNITY_TITLE,
    buildGroups: (ctx) => buildFindATenderGroups(toBuilderProps(ctx)),
    submit: (dispatch, opportunity, formData) =>
      dispatch(
        editFindATenderOpportunityFields({
          id: opportunity.id,
          title: opportunity.title,
          externalLink: formData.externalLink,
          ...(opportunity.estimatedValueIsFromSource
            ? {}
            : { estimatedValue: formData.estimatedValue }),
        })
      ),
  },
  [EBUY_TYPE]: {
    getInitialFormData: (opportunity) => ({
      estimatedValue: opportunity?.estimatedValue ?? "",
      externalLink: opportunity?.externalLink ?? "",
      ...EBUY_ENRICHMENT_FIELDS.reduce(
        (fields, key) => ({ ...fields, [key]: opportunity?.[key] ?? "" }),
        {}
      ),
    }),
    getRequiredFields: () => [],
    getTitle: () => EDIT_OPPORTUNITY_TITLE,
    buildGroups: (ctx) => buildEBuyGroups(toBuilderProps(ctx)),
    submit: (dispatch, opportunity, formData) => {
      const { estimatedValue, ...rest } = formData;
      return dispatch(
        editEBuyOpportunityFromTracked({
          ...rest,
          ...(opportunity.estimatedValueIsFromSource ? {} : { estimatedValue }),
          opportunityId: opportunity.id,
        })
      );
    },
  },
};

export default OPP_EDIT_PANEL_CONFIG;
